import * as React from 'react';
import { EmailTargetEditorView } from './email-target-editor.view';

interface EmailTargetEditorControllerProps {
	mode: ControlMode;
	label?: string;
	value: number | null;
	onChanged: (value: number | null) => void;
	setBusy(isBusy: boolean);
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class EmailTargetEditorController extends React.Component<EmailTargetEditorControllerProps, {}> {
	constructor(props) {
		super(props);
	}


	render() {
		return (
			<EmailTargetEditorView
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/parts/email-target-editor.controller.tsx